export enum ActionType {
  Select = 'select',
  Deselect = 'deselect',
}
